<template>
  <TradePassportCardSlot
    class="trade-passport-dbs"
    title="Experience"
    buttonLabel="+Add Experience"
    :hideFooter="
      tradePassportExperiences && tradePassportExperiences.length <= 3
    "
    emptyStateImage="specialisms-empty"
    :emptyStateLabel="
      isUserProprtyOwner
        ? 'Experience will appear here'
        : 'Your Experience will appear here'
    "
    :isEmpty="!tradePassportExperiences.length"
    :numberOfRemainingItem="tradePassportExperiences.length"
    :isCustomActionHeader="
      tradePassportExperiences && tradePassportExperiences.length
    "
    @on-handle-footer-click="onRouteToExperienceOverview"
    @on-handle-click="onRouteToExperienceOverview"
  >
    <template #custom-action-header>
      <div class="tw-flex tw-gap-3 tw-items-center">
        <Button
          label="+Add"
          variant="secondary"
          class="!tw-w-auto md:!tw-min-h-[unset] md:!tw-px-2"
          v-if="!isUserProprtyOwner"
          @click="onRouteToExperienceOverview"
        />
        <BlueCircularPencilIcon
          v-if="!isUserProprtyOwner"
          @click="onRouteToExperienceOverview"
        />
      </div>
    </template>
    <template #content>
      <div class="tw-w-full">
        <div
          v-for="(experience, index) in tradePassportExperiences.slice(0, 3)"
          :key="index"
          class="tw-w-full tw-flex tw-flex-col tw-gap-4 tw-py-4 tw-box-border"
          :class="{
            'tw-border-b-dashed-custom':
              index !== tradePassportExperiences.slice(0, 3).length - 1,
            '!tw-pt-0': index === 0,
          }"
        >
          <div class="tw-flex tw-items-start tw-gap-3 tw-w-full">
            <div
              class="tw-min-w-[68px] tw-w-[68px] tw-h-[68px] tw-rounded-[4.85px] tw-bg-[rgba(12,15,74,0.04)] tw-border-solid tw-border-[#DFDFDF] tw-border-[1px] tw-overflow-hidden"
            >
              <img
                v-if="experience?.imageUrl"
                :src="experience?.imageUrl"
                class="tw-w-full tw-h-full tw-object-cover"
              />
              <img
                v-else
                src="@/assets/images/tradepassport-empty-thumbnail.png"
                class="tw-w-full tw-h-full tw-object-cover"
              />
            </div>
            <div
              class="tw-w-full tw-flex tw-flex-col tw-gap-[.1rem] tw-items-start"
            >
              <div class="tw-flex tw-items-center tw-gap-2">
                <Text
                  variant="h6"
                  lineHeight="20px"
                  textAlign="left"
                  class="tw-w-[70%] md:!tw-text-[.9rem]"
                  whiteSpace="nowrap"
                  >{{ experience?.companyName }}</Text
                >
              </div>
              <Text
                variant="p"
                textColor="rgba(12, 15, 74, 0.8)"
                lineHeight="18px"
                class="md:!tw-text-[.7rem]"
              >
                {{ experience?.title }}</Text
              >
              <Text
                variant="p"
                textColor="rgba(12, 15, 74, 0.8)"
                lineHeight="18px"
                class="md:!tw-text-[.7rem]"
              >
                {{
                  appFilters.formatToDate(experience?.startDate, "MMMM YYYY")
                }}
                -
                {{
                  experience?.endDate
                    ? appFilters.formatToDate(experience?.endDate, "MMMM YYYY")
                    : "Present"
                }}</Text
              >
            </div>
          </div>
        </div>
      </div>
    </template>
  </TradePassportCardSlot>
</template>
<script setup>
import { computed, ref, onBeforeMount, onMounted } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";

import TradePassportCardSlot from "../slots/TradePassportCardSlot.vue";
import Text from "@/core/components/ui/general/Text.vue";
import Button from "@/core/components/ui/general/Button.vue";
import BlueCircularPencilIcon from "@/core/components/icons/BlueCircularPencilIcon.vue";
import PendingChip from "@/modules/dashboard/components/Chips/PendingChip.vue";
import AcceptChip from "@/modules/dashboard/components/Chips/AcceptChip.vue";
import RejectChip from "@/modules/dashboard/components/Chips/RejectChip.vue";

import { USER_STORE } from "@/store/modules/user";
import { UserRolesEnum } from "@/core/enums/RolesEnum";
import { TRADE_ESTIMATE_STORE } from "@/store/modules/trade-estimate";
import { TRADE_PASSPOSRT_DETAILS_ROUTE } from "../../routes";
import { getCurrentInstance } from "@vue/runtime-core";
import { displayToastMessage } from "@/core/utils/common";
import { UserVerificationStatusEnum } from "@/core/enums/RolesEnum";
import appFilters from "@/filters";

const store = useStore();
const router = useRouter();
const internalInstance = getCurrentInstance();

const loading = ref(false);

const showConfirmDeleteMoal = ref(false);
const selectedId = ref(null);

const user = computed(() => store.getters[`${USER_STORE}/user`]);

const getIsOpenTradePassportasViewMode = computed(
  () => store.getters[`${TRADE_ESTIMATE_STORE}/isOpenTradePassportasViewMode`]
);

const isUserProprtyOwner = computed(
  () =>
    user.value?.role?.name === UserRolesEnum.PROPERTY_OWNER ||
    getIsOpenTradePassportasViewMode.value
);

const tradePassportExperiences = computed(() => {
  return store.getters[`${USER_STORE}/userExperiences`];
});

const onOpenDeleteModal = (id) => {
  selectedId.value = id;
  showConfirmDeleteMoal.value = true;
};

const onCloseDeleteModal = () => {
  showConfirmDeleteMoal.value = false;
};

const onSuccessDelete = async () => {
  selectedId.value = null;
  await initialize();
  onCloseDeleteModal();
  // displayToast here
  displayToastMessage(internalInstance, "Deleted Successfully", "success");
};

const initialize = async () => {
  try {
    loading.value = true;
    if (user.value?.id) {
      await store.dispatch(
        `${USER_STORE}/getAllTradePassportExperience`,
        user.value?.id
      );
    }
  } catch (error) {
    console.error(error);
  } finally {
    loading.value = false;
    console.log(tradePassportExperiences.value, "tradePassportExperiences");
  }
};

const onRouteToExperienceOverview = () => {
  router.push({
    name: TRADE_PASSPOSRT_DETAILS_ROUTE,
    params: { type: "experience" },
  });
};

onBeforeMount(() => {
  initialize();
});
</script>
<style lang="scss" scoped></style>
